import { defineStore } from "pinia"

 const userWeatherStore = defineStore('weather',{
  state:()=>({
     fiverDayForecast:[]
     
  }),
  getters:{},
  actions:{
    setForecast(forecast){
     this.fiverDayForecast = forecast;
    }
  }
})

export default userWeatherStore;